module.exports = __webpack_public_path__ + "img/serviceplanner-planning-parts-de.875519b3.webp";